import { List } from "immutable";
import { createSelector } from "reselect";

import { SectionId, Sections } from "../models/state/sections/Sections";
import { getAllSections } from "./state";
import * as sectionsSelectors from "./state/sections";

type State = any;

export function makeGetDescendantLeafSectionIds(
  sectionId: SectionId
): (arg0: State) => List<SectionId> {
  return createSelector(getAllSections, sections =>
    getDescendantLeafSectionIds(sections, sectionId)
  );
}

export function getDescendantLeafSectionIds(
  sections: Sections,
  sectionId: SectionId
): List<SectionId> {
  return sectionsSelectors
    .getSectionSectionIds(sections, sectionId)
    .reduce((leafSectionIds, subsectionId) => {
      if (sectionsSelectors.isLeafSection(sections, subsectionId)) {
        return leafSectionIds.push(subsectionId);
      } else {
        return leafSectionIds.concat(
          getDescendantLeafSectionIds(sections, subsectionId)
        );
      }
    }, List());
}
